import { useContext, useEffect } from "react";
import { useNavigate } from "react-router-dom";
import { AuthContext } from "../../providers/Auth";
import notification from "../../utils/notification";
import useSendVerificationEmail from "../../api/useSendVerificationEmail";
import Button from "../Button";
import Errors from "../Errors";

export default function VerifyEmail() {
  const sessionContext = useContext(AuthContext);
  const { signOut } = sessionContext;
  const { mutate, isLoading, error, isSuccess } = useSendVerificationEmail();
  const isDone = isSuccess && !error && !isLoading;
  const navigate = useNavigate();

  useEffect(() => {
    if (isDone) {
      notification({ title: "Email Sent", message: "Please check your email and click the link to verify your account." });
    }
  }, [isDone]);

  return (
    <>
      <p>Verify your email</p>
      <Button disabled={isLoading} onClick={() => mutate(null)} variants={["fullWidth"]}>
        Re-send verification email
      </Button>
      <Button
        onClick={async () => {
          if (signOut) {
            await Promise.resolve(signOut());
          }
          navigate("/");
        }}
        variants={["bare", "fullWidth"]}>
        Sign out
      </Button>
      <Errors error={error} />
    </>
  );
}
